export default "__VITE_ASSET__DYyNGBmZ__"